import type { Direction, Position, PlayerId } from '../types';
import type { Letter } from './Letter';
import { generateId } from '../../utils/uuid';

export interface PlacedWord {
  id: string; // Unique word ID (UUID)
  word: string; // The actual word (e.g., "HELLO")
  positions: Position[]; // Cell positions (in order)
  direction: Direction; // horizontal | vertical
  playerId: PlayerId; // Who placed it
  letters: Letter[]; // Letter instances used
  score: number; // Word score (calculated from letter values + bonuses)
  turnNumber: number; // When it was placed
  isValid: boolean; // Dictionary validation (Phase 3)
}

/**
 * Create a new placed word
 */
export function createPlacedWord(
  word: string,
  positions: Position[],
  direction: Direction,
  playerId: PlayerId,
  letters: Letter[],
  score: number,
  turnNumber: number
): PlacedWord {
  return {
    id: generateId(),
    word,
    positions,
    direction,
    playerId,
    letters,
    score,
    turnNumber,
    isValid: true, // Honor system for now (Phase 3 will add dictionary)
  };
}

/**
 * Get the start and end positions of a word
 */
export function getWordBounds(word: PlacedWord): { start: Position; end: Position } {
  return {
    start: word.positions[0],
    end: word.positions[word.positions.length - 1],
  };
}
